"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = useRenderTypingIndicator;

var _useWebChatAPIContext = _interopRequireDefault(require("./internal/useWebChatAPIContext"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function useRenderTypingIndicator() {
  return (0, _useWebChatAPIContext.default)().typingIndicatorRenderer;
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6WyJ1c2VSZW5kZXJUeXBpbmdJbmRpY2F0b3IiLCJ1c2VXZWJDaGF0QVBJQ29udGV4dCIsInR5cGluZ0luZGljYXRvclJlbmRlcmVyIl0sInNvdXJjZVJvb3QiOiJjb21wb25lbnQ6Ly8vIiwic291cmNlcyI6WyIuLi8uLi9zcmMvaG9va3MvdXNlUmVuZGVyVHlwaW5nSW5kaWNhdG9yLnRzIl0sInNvdXJjZXNDb250ZW50IjpbImltcG9ydCB7IFJlbmRlclR5cGluZ0luZGljYXRvciB9IGZyb20gJy4uL3R5cGVzL1R5cGluZ0luZGljYXRvck1pZGRsZXdhcmUnO1xuaW1wb3J0IHVzZVdlYkNoYXRBUElDb250ZXh0IGZyb20gJy4vaW50ZXJuYWwvdXNlV2ViQ2hhdEFQSUNvbnRleHQnO1xuXG5leHBvcnQgZGVmYXVsdCBmdW5jdGlvbiB1c2VSZW5kZXJUeXBpbmdJbmRpY2F0b3IoKTogUmVuZGVyVHlwaW5nSW5kaWNhdG9yIHtcbiAgcmV0dXJuIHVzZVdlYkNoYXRBUElDb250ZXh0KCkudHlwaW5nSW5kaWNhdG9yUmVuZGVyZXI7XG59XG4iXSwibWFwcGluZ3MiOiI7Ozs7Ozs7QUFDQTs7OztBQUVlLFNBQVNBLHdCQUFULEdBQTJEO0VBQ3hFLE9BQU8sSUFBQUMsNkJBQUEsSUFBdUJDLHVCQUE5QjtBQUNEIn0=